<template>
    <el-dialog :visible.sync="revokeDiaVisible" title="撤销原因" width="50%" @close="dialogCancle()">
        <div class="dialogBox">
            <el-form :model="ruleForm" :rules='rules' class="form" label-width="180px" ref="ruleForm">
                <el-row>
                    <el-col :span="12" v-if="!isEdit">
                        <el-form-item label="撤销时间：" size="small">
                            <span>{{ ruleForm.revokeTime }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="撤销原因：" prop="reason" size="small">
                            <el-input :rows="3" clearable maxlength="1000" placeholder="请输入" show-word-limit
                                type="textarea" v-if="isEdit" v-model="ruleForm.reason"></el-input>
                            <span v-else>{{ ruleForm.reason }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="撤销执行人：" prop="displayName" size="small">
                            <el-input clearable disabled maxlength="50" placeholder="请输入" show-word-limit v-if="isEdit"
                                v-model="ruleForm.displayName"></el-input>
                            <span v-else>{{ ruleForm.displayName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="执行部门：" prop="owerDeptName" size="small">
                            <el-input clearable disabled maxlength="50" placeholder="请输入" show-word-limit v-if="isEdit"
                                v-model="ruleForm.owerDeptName"></el-input>
                            <span v-else>{{ ruleForm.owerDeptName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="处理文件文号：" prop="fileName" size="small">
                            <el-input clearable disabled maxlength="50" placeholder="请输入" show-word-limit v-if="isEdit"
                                v-model="ruleForm.fileName"></el-input>
                            <span v-else>{{ ruleForm.fileName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="公开范围：" prop="scopeType" size="small">
                            <el-radio :key="index" :label="item.value" disabled v-for="(item, index) in publicScopeList"
                                v-model="ruleForm.scopeType">{{ item.name }}</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :key="index" :span="24" v-for="(item, index) in ruleForm.attachments">
                        <el-form-item :label="item.fileTypeName ? (item.fileTypeName + '：') : '附件：'"
                            :prop="'attachments' + item.fileType" size="small" v-if="isEdit">
                            <affix-msg :docItem.sync="item" :docName.sync="item.name" @uploadSuccess="uploadSuccess" />
                        </el-form-item>
                        <affix-doc :item.sync="item" :name="item.fileTypeName" class="affixDown" v-else />

                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="dialog-footer" slot="footer" v-if="isEdit">
            <el-button type="primary" @click="dialogCancle()" plain>取消</el-button>
            <el-button @click="saveDetail()" style="margin-bottom:20px;" type="primary">确定</el-button>
        </div>
        <div class="dialog-footer" slot="footer" v-else>
            <el-button type="primary" @click="dialogCancle()" plain>关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>


import { mapState } from "vuex";
import affixMsg from '@/components/affixMsg';
import affixDoc from '@/components/affixDoc';
import { handleMainCreditRepeal } from '@/server/mainCredit.js'
export default {
    name: 'index',
    components: {
        affixMsg,
        affixDoc
    },
    props: {
        type: { type: String },
    },
    computed: {
        ...mapState({
            stateData: state => state.user,
            mainRevokeAttList: (state) => state.dataDictionary.mainRevokeAttList,
            publicScopeList: (state) => state.dataDictionary.publicScopeList,
        }),
    },

    watch: {
        mainRevokeAttList: {
            immediate: true,
            deep: true, // 深度监听
            handler(val, newVal) {
                this.$nextTick(() => {
                    // 初始化附件数据
                    let attachments = JSON.parse(JSON.stringify(this.mainRevokeAttList));
                    this.ruleForm.attachments = attachments;
                    this.addFormRules(this.ruleForm.attachments);
                })
            }
        }
    },
    data() {
        return {

            revokeDiaVisible: false,
            isEdit: true,
            ruleForm: {
                id: '',
                parentId: '',
                owerDeptName: '',
                displayName: '',
                revokeTime: '',
                name: '',
                reason: '',
                fileName: '',
                scopeType: '',
                attachments: [],

            },
            rules: {
                reason: [
                    { required: true, message: '请输入撤销原因', trigger: 'blur' }
                ],
                displayName: [
                    { required: true, message: '请输入撤销执行人', trigger: 'blur' }
                ],
                owerDeptName: [
                    { required: true, message: '请输入执行部门', trigger: 'blur' }
                ],
                fileName: [
                    { required: true, message: '请输入处理文件文号', trigger: 'blur' }
                ],
                scopeType: [
                    { required: true, message: '请选择公开范围', trigger: 'change' }
                ],
            },
        }
    },
    created() {
        this.$store.dispatch('dataDictionary/getMainRevokeAttList');//获取撤销附件配置项数据
    },
    methods: {

        // 添加表单验证规则
        addFormRules(attachments) {
            const _this = this;
            attachments.length > 0 && attachments.forEach((item, index) => {
                if (item.required) {
                    let string = 'attachments' + item.fileType;
                    _this.rules[string] = [
                        {
                            required: true,
                            validator: function (rule, value, callback) {
                                if (_this.ruleForm.attachments[index].filePath) {
                                    callback();
                                } else {
                                    callback(new Error('请上传' + _this.ruleForm.attachments[index].fileTypeName));
                                }
                            }
                        }]
                }
            })

        },
        uploadSuccess(fileType) {
            this.$refs['ruleForm'].clearValidate(['attachments' + fileType]);
        },

        initDialog(data) {
            this.revokeDiaVisible = true;
            this.isEdit = true;
            this.ruleForm = {
                id: '',
                parentId: data.id,
                displayName: this.stateData.displayName,
                owerDeptName: data.owerDeptName || this.stateData.displayName,
                revokeTime: "",
                name: data.name,
                reason: '',
                fileName: data.fileName,
                scopeType: data.scopeType.toString(),
                attachments: [],
            }
            // 附件数据处理start
            let attachments = JSON.parse(JSON.stringify(this.mainRevokeAttList));
            this.ruleForm.attachments = attachments;
            // 附件数据处理end

        },

        //关闭弹窗
        dialogCancle() {
            this.revokeDiaVisible = false;
            this.$refs.ruleForm.clearValidate();
        },
        saveDetail() {

            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.fullscreenLoading = true;
                    let formData = JSON.parse(JSON.stringify(this.ruleForm));
                    formData.type = this.type || '1';
                    handleMainCreditRepeal(formData).then(res => {
                        if (res.data.code == 1) {
                            // this.$message.success("撤销成功！");
                            this.$message({
                                type: 'success',
                                message: '撤销成功！',
                                customClass: 'messageIndex'

                            });
                            this.ruleForm.revokeTime = res.data.data.createTime;
                            this.isEdit = false;
                            const that = this;
                            this.$emit('revokeSuccess')
                            setTimeout(() => {
                                that.dialogCancle()
                            }, 3000)


                        } else {
                            this.$message.error(res.data.msg)
                        }
                    }).finally(() => { this.fullscreenLoading = false; })



                }
            })

        },

    }
}
</script>

<style scoped lang="scss">
.el-dialog__footer {
    width: 100%;

    .dialog-footer {
        width: 155px;
        margin: 0 auto;
    }
}
</style>
<style lang="scss">
.messageIndex {
    z-index: 3000 !important; // // 设置的值一定要比2007大，因为dialog的层级是2007
}
</style>
